module.exports = __webpack_public_path__ + "static/media/submersible-motor.134a64ce.pdf";